import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { environment } from '@environments/environment';
import { BreadcrumbsModule } from '@suvo-bi-core';
import {
  AccountSidenavWidgetModule,
  DataSourceFavouritesModule,
  FiltersModule,
  ListNavigationModule,
} from '@suvo-bi-lib';
import { SubscriptionModule } from '@suvo-bi-users';
import { SharedModule } from '../../../shared/shared.module';
import { CustomerFooterComponent } from './components/customer-footer/customer-footer.component';
import { CustomerHeaderComponent } from './components/customer-header/customer-header.component';
import { MainOutletComponent } from './components/main-outlet/main-outlet.component';
import { MainSidenavComponent } from './components/main-sidenav/main-sidenav.component';
import { NavigationOutletModule } from './components/navigation-outlet/navigation-outlet.module';

@NgModule({
  declarations: [
    MainOutletComponent,
    MainSidenavComponent,
    CustomerFooterComponent,
    CustomerHeaderComponent,
  ],
  imports: [
    CommonModule,
    DataSourceFavouritesModule,
    SharedModule,
    FiltersModule,
    ListNavigationModule,
    BreadcrumbsModule,
    NavigationOutletModule,
    AccountSidenavWidgetModule.forRoot({ contactEndpoint: environment.dataServiceApi }),
    SubscriptionModule,
  ],
  exports: [MainOutletComponent, CustomerHeaderComponent],
})
export class CustomerNavigationModule {}
